import { fetchOfficeComponentContext } from '@office-start/component-context-service';
import { useQuery } from '@office-start/data-fetching';
import { useFeatureSettings } from '@office-start/feature-settings-service';
import { fetchIdentity } from '@office-start/identity-service';
import { fetchConfigInternal } from '../fetchConfigInternal';
import { defaultPrefetchOptions } from '../models/defaultPrefetchOptions';
/**
 * Generic hook which can be used to access office-start's configuration data via ReactQuery cache.
 */
// TODO: Fix type implementation so utilizing functions do not need to specify the type of the query result.
export function useConfig(options) {
    // Use useFeatureSettings hook to ensure feature settings are available.
    useFeatureSettings();
    var key = options.key;
    var queryKey = [key];
    return useQuery(queryKey, function () {
        var fetchDataPromisesObject = {
            contextPromise: fetchOfficeComponentContext(),
            identityPromise: fetchIdentity(),
        };
        return fetchConfigInternal(fetchDataPromisesObject, options);
    }, defaultPrefetchOptions);
}
//# sourceMappingURL=useConfig.js.map